import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React from "react";

interface NestedListWhenDrawerOpenedProps extends React.PropsWithChildren<any> {
  collapse: () => void;
  expand: () => void;
  open: boolean;
  text: string;
  toggleNestedListOpen: () => void;
  Icon?: any;
}

export const NestedListWhenDrawerOpened: React.FC<NestedListWhenDrawerOpenedProps> = (
  props: NestedListWhenDrawerOpenedProps
) => {
  const {
    children,
    collapse,
    expand,
    open,
    text,
    toggleNestedListOpen,
    Icon
  } = props;

  return (
    <>
      <ListItem
        key="header"
        button={true}
        onClick={toggleNestedListOpen}
        onMouseEnter={expand}
        onMouseLeave={collapse}
      >
        <ListItemIcon style={{ paddingLeft: "6px" }}>
          <Icon />
        </ListItemIcon>

        <ListItemText>{text}</ListItemText>

        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse key="body" in={open} unmountOnExit={true}>
        <List>{children}</List>
      </Collapse>
    </>
  );
};
